/**
 * Client-side filtering of the user list.
 *
 * Cohort membership is an array on the user now rather than a UserCohort join
 * table, so matching is a lookup instead of a walk.
 */
export const applyFilter = (users = [], filters = {}) => {
  const { cohortId, accountType } = filters;

  return users.filter((user) => {
    if (accountType && user.accountType !== accountType) return false;
    if (cohortId && !(user.cohorts ?? []).some(({ id }) => id === cohortId)) return false;
    return true;
  });
};
